import React, { useState } from 'react';
import { TableHeaderComponent } from './TableHeaderComponent';
import { TableRowComponent, TableRowType } from './TableRowComponent';
import { getTheme, Text } from '@fluentui/react';
import { borderTopStyle } from './BorderStyles';

export interface TableComponentProps {
  data: TableRowType[];
  clickable: boolean;
  tableTitle?: string;
  isButton?: boolean;
}

export const TableComponent: React.FunctionComponent<TableComponentProps> = props => {
  const [rowIndex, setRowIndex] = useState(-1);
  const [rowIsClicked, setRowClickStatus] = useState(false);
  const { palette } = getTheme();
  const borderTop = borderTopStyle(palette);
  const rowStyleUnselected = {
    ...borderTop,
    cursor: 'pointer'
  };
  const rowStyleSelected = {
    ...borderTop,
    cursor: 'pointer',
    backgroundColor: 'rgba(24, 181, 162, 0.08)'
  };
  const handleRowIndex = (index: number) => {
    if (rowIsClicked) {
      setRowIndex(-1);
      setRowClickStatus(false);
    } else {
      setRowIndex(index);
      setRowClickStatus(true);
    }
  };
  return (
    <table className="w-100" style={{ borderCollapse: 'collapse' }}>
      <tbody>
        {props.tableTitle && (
          <tr>
            <td colSpan={3} className="pt-3 pb-3 pl-4 text-nowrap">
              <Text variant="xxLarge">{props.tableTitle}</Text>
            </td>
          </tr>
        )}
        <tr>{props.data && props.data[0] && <TableHeaderComponent row={props.data[0]} />}</tr>
      </tbody>
      <tbody>
        {props.data && props.data.length === 0 && (
          <tr>
            <td className="p-5">
              <Text className="p-5">No data found.</Text>
            </td>
          </tr>
        )}
        {props.data &&
          props.data.map((row, index) => {
            if (props.clickable) {
              return (
                <tr
                  key={index}
                  onClick={() => handleRowIndex(index)}
                  style={rowIndex === index ? rowStyleSelected : rowStyleUnselected}
                >
                  <TableRowComponent row={row} />
                </tr>
              );
            } else {
              return (
                <tr key={index} style={borderTop}>
                  <TableRowComponent row={row} />
                </tr>
              );
            }
          })}
      </tbody>
    </table>
  );
};
